
import 'date-fns';
import React from 'react';
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
import "moment/locale/es";
import esLocale from "date-fns/locale/es";
// import TextField from '@material-ui/core/TextField';
import {
  MuiPickersUtilsProvider,
  // KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';

const renderTextField = ({ input, label, name, type, withFocus, meta: { touched, error }, disabled}) => {
    /* const [selectedDate, setSelectedDate] = React.useState(new Date('2014-08-18T21:11:54'));

    const handleDateChange = date => {
        setSelectedDate(date);
    }; */
    return <div>
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
            <Grid >
                <KeyboardDatePicker
                    {...input}
                    margin="normal"
                    id="date-picker-dialog"
                    name={label}
                    label={label}
                    format="dd/MM/yyyy"
                    disabled = {disabled}
                    autoOk
                    variant="inline"
                    // value={selectedDate}
                    // onChange={handleDateChange}
                    KeyboardButtonProps={{
                        'aria-label': 'change date',
                    }}
                />
            </Grid>
            </MuiPickersUtilsProvider>
                
                {touched && error && <span>{error}</span>}
            </div>
}

/* renderTextField.propTypes = {
     
}; */

export default renderTextField;